import { Controller } from "@hotwired/stimulus"

// Submits a form immediately or after a quiet typing interval.
export default class extends Controller {
  static values = { delay: { type: Number, default: 200 } }

  disconnect() {
    clearTimeout(this.timeout)
  }

  submit(event) {
    if (event.isComposing) return

    event.preventDefault()
    clearTimeout(this.timeout)
    this.element.requestSubmit()
  }

  submitLater(event) {
    if (event.isComposing) return

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }
}
